module.exports = __webpack_public_path__ + "img/new-year-dark-small.4ed96a59.svg";